const state = {
  articleCount: 0,
  articles: [],
  contentTypes: [],
  articleFilters: [],
  selectedFilter: 'All',
  selectedTab: 'Home',
  currentPage: 1,
  pageCount: 0,
  isArticlesLoading: true,
  selectedTag: ''
}

const mutations = {
  setArticles (state, articles) {
    state.articles = articles
  },
  setCurrentPage (state, currentPage) {
    state.currentPage = currentPage
  },
  setArticleCount (state, articleCount) {
    state.articleCount = articleCount
  },
  setArticleFilters (state, articleFilters) {
    state.articleFilters = articleFilters
  },
  setContentTypes (state, contentTypes) {
    state.contentTypes = contentTypes
  },
  setPageCount (state, pageCount) {
    state.pageCount = pageCount
  },
  setIsArticlesLoading (state, bool) {
    state.isArticlesLoading = bool
  },
  setSelectedTab (state, tab) {
    state.selectedTab = tab
  },
  setSelectedTag (state, selectedTag) {
    state.selectedTag = selectedTag
  },
  setSelectedFilter (state, selectedFilter) {
    state.selectedFilter = selectedFilter
  }
}

module.exports = {
  namespaced: true,
  state,
  getters: {},
  mutations,
  actions: {}
}
